module.exports = __webpack_public_path__ + "static/piclife_img2-6768378c75839bf9083f294335cf2d54.png";